import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { useVariant } from "../../context/VariantContext";
import { SERVICES } from "../../data/content";
import { Reveal } from "./Reveal";
import { SectionEyebrow } from "./About";

export const Services = () => {
  const { variant } = useVariant();
  const [open, setOpen] = useState(0);

  return (
    <section
      id="services"
      data-testid="services"
      className="relative border-t px-6 py-28 lg:px-10 lg:py-36"
      style={{ borderColor: "var(--border)" }}
    >
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Reveal>
              <SectionEyebrow index="03">Services</SectionEyebrow>
              <h2 className="font-head mt-6 text-4xl leading-tight text-[color:var(--text)] sm:text-5xl">
                Expertise, engaged on your terms.
              </h2>
              <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-[color:var(--text-2)]">
                From a single grail piece to enterprise authentication programs and
                the courtroom — trusted by collectors, brands, platforms and counsel.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:col-start-6">
            <div className="border-t" style={{ borderColor: "var(--border)" }}>
              {SERVICES.map((s, i) => {
                const active = open === i;
                return (
                  <Reveal key={s.title} delay={i * 0.05}>
                    <div className="border-b" style={{ borderColor: "var(--border)" }}>
                      <button
                        data-testid={`service-${i}`}
                        onClick={() => setOpen(active ? -1 : i)}
                        className="flex w-full items-center gap-5 py-7 text-left"
                      >
                        <span
                          className="font-accent text-xs tabular-nums"
                          style={{ color: "var(--accent)" }}
                        >
                          0{i + 1}
                        </span>
                        <span
                          className={`font-head flex-1 text-2xl text-[color:var(--text)] sm:text-3xl ${
                            variant === "swiss" ? "font-bold tracking-tight" : ""
                          }`}
                        >
                          {s.title}
                        </span>
                        <span
                          className="flex h-9 w-9 shrink-0 items-center justify-center border transition-colors"
                          style={{
                            borderColor: "var(--border)",
                            background: active ? "var(--accent)" : "transparent",
                            color: active ? "var(--on-accent)" : "var(--text)",
                            borderRadius: "var(--radius-tok)",
                          }}
                        >
                          {active ? <Minus size={16} /> : <Plus size={16} />}
                        </span>
                      </button>
                      <AnimatePresence initial={false}>
                        {active && (
                          <motion.div
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: "auto", opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                            className="overflow-hidden"
                          >
                            <p className="max-w-xl pb-8 pl-9 text-[15px] leading-relaxed text-[color:var(--text-2)]">
                              {s.detail}
                            </p>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
